"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortParamFormatter = void 0;
function sortParamFormatter(sortField, sortOrder) {
    if (sortField && sortOrder) {
        return `${sortField}.${sortOrder}`;
    }
    return undefined;
}
exports.sortParamFormatter = sortParamFormatter;
//# sourceMappingURL=sort_params.js.map